import React, { useContext, useEffect, useState } from "react";
import { GMCContext } from "../src/GMCContext";
import axios from "axios";
import Web3 from "web3";
import Header from "./Components/Common/Header";
import Sidebar from "./Components/Common/Sidebar";
import Footer from "./Components/Common/Footer";
const web3 = new Web3(process.env.REACT_APP_RPC);


export default function Cron() {
   const { setIsSidebarEnabled, formatDateTime } = useContext(GMCContext);
  
  const [countDown1, setCountDown1] = useState("00:00:00");
  const headerHeight = 70;
  const date1 = new Date(); // Current date
  date1.setDate(date1.getDate() + 1); // Add 1 day
  const deadline1 = date1.setHours(0, 1, 0, 0); // Set hours to 10 and minutes to 25;


  const getTime1 = () => {
    const time = new Date(deadline1) - Date.now();
    setCountDown1(
      `${Math.floor(time / (1000 * 60 * 60))}:${Math.floor((time / 1000 / 60) % 60)}:${Math.floor((time / 1000) % 60)}`
    );
  };

  useEffect(() => {
    const interval = setInterval(() => getTime1(deadline1), 1000);
    return () => clearInterval(interval);
  }, []);

  const [countDown2, setCountDown2] = useState("00:00:00");
  const date2 = new Date(); // Current date
  date2.setDate(date2.getDate() + 1); // Add 1 day
  const deadline2 = date2.setHours(0, 10, 0, 0); // Set hours to 10 and minutes to 25;


  const getTime2 = () => {
    const time = new Date(deadline2) - Date.now();
    setCountDown2(
      `${Math.floor(time / (1000 * 60 * 60))}:${Math.floor((time / 1000 / 60) % 60)}:${Math.floor((time / 1000) % 60)}`
    );
  };

  useEffect(() => {
    const interval = setInterval(() => getTime2(deadline2), 1000);
    return () => clearInterval(interval);
  }, []);

  const [countDown3, setCountDown3] = useState("00:00:00");
  const date3 = new Date(); // Current date
  date3.setDate(date3.getDate() + 1); // Add 1 day
  const deadline3 = date3.setHours(0, 20, 0, 0); // Set hours to 10 and minutes to 25;


  const getTime3 = () => {
    const time = new Date(deadline3) - Date.now();
    setCountDown3(
      `${Math.floor(time / (1000 * 60 * 60))}:${Math.floor((time / 1000 / 60) % 60)}:${Math.floor((time / 1000) % 60)}`
    );
  };

  useEffect(() => {
    const interval = setInterval(() => getTime3(deadline3), 1000);
    return () => clearInterval(interval);
  }, []);

  const [countDown4, setCountDown4] = useState("00:00:00");
  const date4 = new Date(); // Current date
  date4.setDate(date4.getDate() + 1); // Add 1 day
  const deadline4 = date4.setHours(0, 25, 0, 0); // Set hours to 10 and minutes to 25;


  const getTime4 = () => {
    const time = new Date(deadline4) - Date.now();
    setCountDown4(
      `${Math.floor(time / (1000 * 60 * 60))}:${Math.floor((time / 1000 / 60) % 60)}:${Math.floor((time / 1000) % 60)}`
    );
  };

  useEffect(() => {
    const interval = setInterval(() => getTime4(deadline4), 1000);
    return () => clearInterval(interval);
  }, []);

  const [countDown5, setCountDown5] = useState("00:00:00");
  const date5 = new Date(); // Current date
  date5.setDate(date5.getDate() + 1); // Add 1 day
  const min = date5.getMinutes();
  const rem = min % 5;
  const plus = rem !== 0 ? 5 - rem : 5;
  const hr = date5.getHours();
  const cmin = date5.getMinutes();
  date5.setDate(new Date().getDate());
  const [deadline5, setDeadline5] = useState(date5.setHours(hr, cmin + plus, 0, 0));


  const getTime5 = () => {
    const time = new Date(deadline5) - Date.now();
    if (time > 0) {
      setCountDown5(
        `${Math.floor(time / (1000 * 60 * 60))}:${Math.floor((time / 1000 / 60) % 60)}:${Math.floor(
          (time / 1000) % 60
        )}`
      );
    } else {
      let newd = new Date();
      newd.setDate(newd.getDate() + 1); // Add 1 day
      const min = newd.getMinutes();
      const rem = min % 5;
      const plus = rem !== 0 ? 5 - rem : 5;
      const hr = newd.getHours();
      const cmin = newd.getMinutes();
      newd.setDate(new Date().getDate());
      setDeadline5(newd.setHours(hr, cmin + plus, 0, 0));
    }
  };

  useEffect(() => {
    const interval = setInterval(() => getTime5(deadline5), 1000);
    return () => clearInterval(interval);
  }, [deadline5]);

  return (
    <>
      <div id="layout-wrapper">
        <Header />
        <Sidebar />

        {/* Main Content */}
        <div
          className="main-content" onClick={() => setIsSidebarEnabled((prev) => !prev)}
          style={{
            marginTop: `${headerHeight}px`, // Matches header height
            padding: '20px', // Adds padding around the content
            minHeight: `calc(100vh - ${headerHeight}px - 50px)`, // Adjust height for footer
            boxSizing: 'border-box', // Ensures padding is included in height
          }}
        >
          <div className="row g-3" style={{ paddingBottom: '20px', marginBottom: '30px' }}>
            <div className="d-flex justify-content-between align-items-center">
              {/* Left Section */}
              <div className="flex-grow-1">
                <h4 className="fs-16 mb-1">Welcome to, Scheduled Crons!</h4>
                {/* <p className="text-muted mb-0">
                                    Here's what's happening with your store today</p> */}
              </div>

              {/* Right Section */}
              <div className="mt-3 mt-lg-0">
                <form action="javascript:void(0);">
                  <div className="row g-3 mb-0 align-items-center">
                    <div className="col-sm-auto">

                    </div>

                  </div>
                </form>
              </div>
            </div>

            {/* Cards Section */}

            <div className="col-xl-3 col-md-2">
              <div className="card card-animate">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1 overflow-hidden">
                      <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                        Mining Reward
                      </p>
                    </div>
                  </div>
                  <div className="d-flex align-items-end justify-content-between mt-4">
                    <div>
                      <h2 className="fs-40 font-w600 text-white mb-0 me-3">{countDown1}</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6">
              <div className="card card-animate">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1 overflow-hidden">
                      <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                        Staking Reward
                      </p>
                    </div>
                  </div>
                  <div className="d-flex align-items-end justify-content-between mt-4">
                    <div>
                      <h2 className="fs-40 font-w600 text-white mb-0 me-3">{countDown2}</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6">
              <div className="card card-animate">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1 overflow-hidden">
                      <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                        Get Unstake Data
                      </p>
                    </div>
                  </div>
                  <div className="d-flex align-items-end justify-content-between mt-4">
                    <div>
                      <h2 className="fs-40 font-w600 text-white mb-0 me-3">{countDown3}</h2>

                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6">
              <div className="card card-animate">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1 overflow-hidden">
                      <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                        Unstake Call
                      </p>
                    </div>
                  </div>
                  <div className="d-flex align-items-end justify-content-between mt-4">
                    <div>
                      <h2 className="fs-40 font-w600 text-white mb-0 me-3">{countDown4}</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6">
              <div className="card card-animate">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1 overflow-hidden">
                      <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                        Next Withdrawal Start In
                      </p>
                    </div>
                  </div>
                  <div className="d-flex align-items-end justify-content-between mt-4">
                    <div>
                      <h2 className="fs-40 font-w600 text-white mb-0 me-3">{countDown5}</h2>

                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-xl-3 col-md-6">
              <div className="card card-animate">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1 overflow-hidden">
                      <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                        Roi of Roi
                      </p>
                    </div>
                  </div>
                  <div className="d-flex align-items-end justify-content-between mt-4">
                    <div>
                      <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                        $ <span>{data?.lrewards ? parseFloat(data?.rorReward).toFixed(2) : "0"}</span>
                      </h4>
                      Click on: <a href="roiofroisidebar" className="text-decoration-underline">Roi of Roi Report</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6">
              <div className="card card-animate">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1 overflow-hidden">
                      <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                        Total Pending Withdrawal
                      </p>
                    </div>
                  </div>
                  <div className="d-flex align-items-end justify-content-between mt-4">
                    <div>
                      <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                        $ <span>{data?.pwithdrawlD ? data?.pwithdrawlD : "0"}</span>
                      </h4>
                      Click on: <a href="pendingwithdrwalsidebar" className="text-decoration-underline">See Pending Withdrawal</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6">
              <div className="card card-animate">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1 overflow-hidden">
                      <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                        Total Withdrawal
                      </p>
                    </div>
                  </div>
                  <div className="d-flex align-items-end justify-content-between mt-4">
                    <div>
                      <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                        $ <span>{data?.withdrawl ? data?.withdrawl : "0"}</span>
                      </h4>
                      Click on: <a href="withdrwalsidebar" className="text-decoration-underline">See Withdrawal Report</a>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </>
  );
}
